export const themeConstants = {
  paddingXL: "30px",
  paddingL: "20px",
  paddingM: "15px",
  paddingS: "10px"
}

export const lightColors = {
  accent: "#9E7C6B",
  text: "#424D4D",
  fieldCaption: "#8F8F8F",
  border: "#424242",
  borderHover: "#8F8F8F",
  bg: "#FFF",
  textFieldLabel: "#A1A1A1",
  textFieldBorder: "#E0E0E0",
  textFieldText: "#1E1E1E"
}

export const darkColors = {
  accent: "#AEDCCF",
  text: "#FFF",
  fieldCaption: "#A1A1A1",
  border: "#424242",
  borderHover: "#757575",
  bg: "#0D0F0F",
  textFieldLabel: "#A1A1A1",
  textFieldBorder: "#e0e0e03c",
  textFieldText: "#1E1E1E"
}


export const olympicColors = {
  accent: "#2D7AFF",
  text: "#424D4D",
  fieldCaption: "##BDBDBD",
  border: "#424242",
  borderHover: "#8F8F8F",
  bg: "#FFF",
  textFieldLabel: "#A1A1A1",
  textFieldBorder: "#E0E0E0",
  textFieldText: "#1E1E1E"
}

export const olympicFonts1 = [
  'Arial',
  'Nunito',
  '-apple-system',
  'BlinkMacSystemFont',
  '"Segoe UI"',
  'Roboto',
  '"Helvetica Neue"',
  'sans-serif',
  '"Apple Color Emoji"',
  '"Segoe UI Emoji"',
  '"Segoe UI Symbol"',
].join(',');


export const olympicFonts2 = [
  '"RF Dewi Extended"',
  'Nunito',
  '-apple-system',
  'BlinkMacSystemFont',
  '"Segoe UI"',
  'Roboto',
  '"Helvetica Neue"',
  'sans-serif',
  '"Apple Color Emoji"',
  '"Segoe UI Emoji"',
  '"Segoe UI Symbol"',
].join(',');


export const breakpoints = {
  values: {
    xs: 0,
    sm: 380,
    md: 600,
    lg: 900,
    xl: 1200,
  },
}
